import _extends from "@babel/runtime/helpers/esm/extends";
export const addReCaptchaSDK = (url, recaptchaSDKId = 'recaptcha-jssdk') => {
  // Check it has not already been intanciated - if it has -> still re-init reCaptcha
  if (document.getElementById(recaptchaSDKId)) {
    window.initReCaptcha();
    return;
  }
  const firstScriptTag = document.getElementsByTagName('script')[0];
  const googleSDKScriptTag = document.createElement('script');
  googleSDKScriptTag.id = recaptchaSDKId;
  googleSDKScriptTag.async = true;
  googleSDKScriptTag.defer = true;
  googleSDKScriptTag.src = url;
  if (firstScriptTag.parentNode) {
    firstScriptTag.parentNode.insertBefore(googleSDKScriptTag, firstScriptTag);
  }
};
export const buildSDKUrl = options => {
  options = _extends({
    render: 'explicit'
  }, options);
  const url = new URL('https://www.google.com/recaptcha/enterprise.js');
  Object.entries(options).forEach(([key, param]) => param && url.searchParams.append(key, param));
  return url.href;
};
//# sourceMappingURL=loader.js.map